import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ncc-redirect',
  template: ` <div class="ui loading segment" style="height:100%"></div> `,
  styles: [],
})
export class RedirectComponent implements OnDestroy {
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  private unsubscribe$: Subject<void> = new Subject<void>();
  pending = true;
  error;
  token: string;
  r: string;
  message;
  redirectRoute = '';
  applicationType;
  routeParams;
  redirect_params: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: AuthenticationService
  ) {
    this.route.queryParams.subscribe((params) => {
      // const token = params['theDestParamterIsentYou'];
      this.token = params['token'];
      this.redirectRoute = params['route'];
      this.message = params['message'];
      this.r = params['redirect_url'];
      this.redirect_params = params['redirect_params'];
      // this.r = `${params['redirect_url']}?${params['redirectParams']}`;
      this.applicationType = params['type'];
      // get query params passed along with redirected route
      this.routeParams = params['routeBody']
        ? JSON.parse(params['routeBody'])
        : '';

      if (this.token) {
        this.login();
      } else {
        this.internal();
      }
    });
  }

  internal() {
    const role = JSON.parse(window.localStorage.getItem('user')).organizationId
      .organizationTypeId.organizationTypeId;
    if (role) {
      if (window.localStorage.getItem('url')) {
        const url = `/${window.localStorage.getItem('url')}`;
        window.location.replace(url);
        window.localStorage.removeItem('url');
      } else if (role === 'contractor') {
        this.router.navigate(['/contractor']);
      } else {
        this.router.navigate(['/admin']);
      }
    } else {
      this.router.navigate(['']);
    }
  }

  login() {
    this.pending = true;
    this.userService
      .login({ token: this.token })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          // this.pending = false;
          // this.success = "Congratulations! Please click on the button below to proceed to the contractor
          // dashboard in order to complete your registration ";
          this.userService.setUserValue(res.appUser);
          window.localStorage.setItem('jwt', res.token);
          window.localStorage.setItem('user', JSON.stringify(res.appUser));
          window.localStorage.setItem(
            'organizationId',
            res.appUser.organizationId.organizationId
          );
          window.localStorage.setItem(
            'organization',
            JSON.stringify(res.appUser.organizationId)
          );
          window.localStorage.setItem(
            'permissions',
            JSON.stringify(res['permissions'])
          );
          window.localStorage.setItem(
            'permission',
            JSON.stringify(res['permissions'])
          );
          const role =
            res.appUser.organizationId.organizationTypeId.organizationTypeId;

          setTimeout(() => {
            this.pending = false;
            if (window.localStorage.getItem('pendingRedirect')) {
              window.location.replace(
                window.localStorage.getItem('pendingRedirect')
              );
            } else {
              if (window.localStorage.getItem('url')) {
                const url = `/${window.localStorage.getItem('url')}`;
                window.location.replace(url);

                window.localStorage.removeItem('url');
              } else if (
                role === 'contractor' ||
                role === 'mda' ||
                role === 'company'
              ) {
                if (this.redirectRoute) {
                  if (this.routeParams) {
                    this.router.navigate([this.redirectRoute], {
                      queryParams: this.routeParams,
                    });
                  } else {
                    this.router.navigate([this.redirectRoute]);
                  }
                } else {
                  this.router.navigate(['/contractor/dashboard']);
                }

                if (this.message) {
                  localStorage.setItem('message', this.message);
                }
                if (this.r) {
                  localStorage.setItem('redirect_url', this.r);
                  localStorage.setItem('redirect_params', this.redirect_params);
                }
                if (this.applicationType) {
                  localStorage.setItem(
                    'application_type',
                    this.applicationType
                  );
                }
              } else {
                this.router.navigate(['/admin']);
              }
            }
          }, 2000);
        },
        (error) => {
          this.pending = false;
          if (error.status === 400) {
            this.error = error.error['developerMessage'];
            this.router.navigate(['/home-page/dashboard']);
          } else {
            this.router.navigate(['/home-page/dashboard']);
            this.error = error['developerMessage'];
          }
        }
      );
  }
  // private _resize$: Observable<number>;
  // mobile$ = this.sb.mobile$;
  // tablet$ = this.sb.tablet$;
  // desktop$ = this.sb.desktop$;

  // ngOnInit(): void {
  //   this._resize$ = Observable.fromEvent(window, 'resize')
  //     .pipe(
  //       debounceTime(200),
  //       mapTo( window.innerWidth),
  //       distinctUntilChanged(),
  //       startWith(window.innerWidth),
  //       tap(width => this.sb.setWindowWidth(width))
  //     );
  //   this._resize$.subscribe();
  // }
}
